import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router/routes.js'
import i18n from './i18n/translations.js'
import Vuelidate from 'vuelidate'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import VueSession from 'vue-session'
import {
  VLazyImagePlugin
} from 'v-lazy-image'

Vue.config.productionTip = false

Vue.use(VueSession)
Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VLazyImagePlugin)

new Vue({
  el: '#app',
  vuetify,
  axios,
  router,
  i18n,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
